/* template */
<template><div class="mpx-root-view"><page/><es-dialog id="es-dialog"/><es-dialog id="es-dialog-conceal-login"><div slot="content"><div class="protocol text">我阅读并同意以下协议</div><mpx-view @tap="goto" class="protocol url">《账户授权协议》</mpx-view><div class="protocol text">同意受本协议约束</div></div></es-dialog><es-dialog id="es-dialog-book"><div slot="content" class="bottom-conceal-text">我阅读并同意以下协议<mpx-view v-for="(item, index) in (purchaseList)" :key="item.index" @tap="jumpToLicense(item, index)" class="protocol url">《{{ item.name }}》</mpx-view></div></es-dialog></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4862ccf6"}'>
  .protocol
    font-size 14px
    display inline
    line-height 17px
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color #666
    &.url
      color #338FFF
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4862ccf6"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index-backup.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index-backup.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m4862ccf6"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'page':getComponent(require("./index.mpx?isComponent&outputPath=components%2Findex0f7f0447%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
